import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import { baseApi } from '@/shared/api/baseApi';
import { authReducer, setCurrentEnv } from '@/features/auth/authSlice';
import { editModeReducer } from '@/features/editMode/editModeSlice';

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: setCurrentEnv,
  effect: async (_action, api) => {
    api.dispatch(baseApi.util.resetApiState());
  },
});

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    auth: authReducer,
    editMode: editModeReducer,
  },
  middleware: (gDM) => gDM().prepend(listenerMiddleware.middleware).concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
